import { Dispatch } from "redux";
import CatalogStockService from "service/CatalogStock";
import { showMessage } from "utilities/helper";
import { CatalogStockPayloadTypes } from "utilities/types/CatalogStock";
import { setLoadingModal } from "./global";
import { getCatalogById } from "./catalog";

export const getAllCatalogStocks =
  (
    catalogId: string,
    page: number = 1,
    search: string = "",
    limit: number = 10
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoadingModal(true));
    dispatch({
      type: "SET_CATALOG_STOCK_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_CATALOG_STOCK",
      searchValue: search,
    });

    try {
      const data = await CatalogStockService.getAllCatalogStocks(
        catalogId,
        page,
        search,
        limit
      );

      dispatch(setLoadingModal(false));
      dispatch({
        type: "SET_CATALOG_STOCK",
        value: data.stocks,
      });
      dispatch({
        type: "SET_CATALOG_STOCK_PAGE",
        totalPage: !!data.stocks.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.stocks.length ? data.total_data : 1,
      });
    } catch (err: any) {
      dispatch(setLoadingModal(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const storeCatalogStock =
  (
    catalogId: string,
    form: CatalogStockPayloadTypes,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await CatalogStockService.storeCatalogStock(payload);
      const { currentPage, searchValue, limitPage } =
        getState().catalogStockReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllCatalogStocks(
          catalogId,
          currentPage,
          searchValue,
          limitPage
        ) as any
      );
      dispatch(getCatalogById(catalogId) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateCatalogStock =
  (
    catalogStockId: string,
    catalogId: string,
    form: CatalogStockPayloadTypes,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await CatalogStockService.updateCatalogStock(
        catalogStockId,
        payload
      );
      const { currentPage, searchValue, limitPage } =
        getState().catalogStockReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllCatalogStocks(
          catalogId,
          currentPage,
          searchValue,
          limitPage
        ) as any
      );
      dispatch(getCatalogById(catalogId) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteCatalogStock =
  (catalogStockId: string, catalogId: string, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });

    try {
      const data = await CatalogStockService.deleteCatalogStock(catalogStockId);
      const { currentPage, searchValue, limitPage } =
        getState().catalogStockReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllCatalogStocks(
          catalogId,
          currentPage,
          searchValue,
          limitPage
        ) as any
      );
      dispatch(getCatalogById(catalogId) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const importCatalogStock =
  (catalogId: string, importFile: File) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_IMPORT_LOADING", value: true });
    try {
      const data = await CatalogStockService.importCatalogStock(
        catalogId,
        importFile
      );
      const { currentPage, searchValue, limitPage } =
        getState().catalogStockReducer;

      dispatch({ type: "SET_IMPORT_LOADING", value: false });

      dispatch(
        getAllCatalogStocks(
          catalogId,
          currentPage,
          searchValue,
          limitPage
        ) as any
      );
      dispatch(getCatalogById(catalogId) as any);
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_IMPORT_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };
